import { useTranslation } from 'react-i18next';
import { Button } from './Button';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">
            {t('errors.generic')}
          </h1>
          <p className="text-gray-600 mb-6">{error.message}</p>
          <Button onClick={resetErrorBoundary} className="btn-primary">
            {t('common.back')}
          </Button>
        </div>
      </div>
    </div>
  );
}

